import FastClick from 'fastclick';



FastClick.attach(document.body);



// WEBPACK FOOTER //
// ./src/vendor/fastclick/index.js